module.exports = __webpack_public_path__ + "img/en-ca.5c5dfa97.svg";